import React from "react";
import styled from "styled-components";
import ReactModal from "react-modal";
import Button from "../Button";
import { getBorder, getBorderRadius, mq, getShadow } from "../utils";
import { settings } from "shared";

type Props = Pick<ReactModal, "isOpen" | "onRequestClose" | "children"> & {
  hideCloseButton?: boolean;
  zIndex?: number;
};

const ModalWrapper = styled(ReactModal)`
  max-height: calc(100% - 100px);
  width: 750px;
  margin: auto;
  top: 40px;
  border: ${getBorder("default")};
  background-color: rgb(255, 255, 255);
  border-radius: ${getBorderRadius("default")};
  outline: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  transition: height 0.3s ease;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: ${getShadow("panel")};
  overflow: hidden;
  max-width: 100%;

  ${mq.xs`
    maxHeight: 100%;
    top: 0;
    bottom: 0;
  `}
`;

const Modal: React.FC<Props> = ({
  children,
  isOpen,
  onRequestClose,
  hideCloseButton = false,
  zIndex,
}) => {
  const modalProps = {
    isOpen,
    onRequestClose,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    style: {
      overlay: {
        zIndex: zIndex || 70,
      },
    },
  };
  return (
    <ModalWrapper ariaHideApp={settings.environment !== "test-runner"} {...modalProps}>
      {!hideCloseButton && (
        <Button
          buttonStyle="tertiary"
          aria-label="Close"
          icon="close"
          onClick={onRequestClose}
          width="36px"
          height="36px"
          position="absolute"
          top="0"
          right="0"
          zIndex="50"
        />
      )}

      {children}
    </ModalWrapper>
  );
};

export default Modal;
